<template>
  <div id="index">
    <!-- 过渡区域 -->
    <div class="bridge" v-if="loading || message">
      <div class="loadingArea" v-if="loading">
        <img class="loading" src="../assets/img/loading.gif">
        <div class="loading-note">加载中...</div>
      </div>
      <div class="errorArea" v-if="message">
        <img class="error" src="../assets/img/error.png">
        <div class="message">{{message}}</div>
        <div class="btn" @click="btnAction">确定</div>
      </div>
    </div>
    <!-- 模板区域 -->
    <div class="templateArea" v-else>
      <!-- 模板一为孔明灯 -->
      <template-light
        :baseData="baseData"
        :query="param"
        :itemStatus="itemStatus"
        :rightClass="rightClass"
        :logout.sync="logout"
        :exceptionUA="exceptionUA"
        :needFocus.sync="needFocus"
        @login="handleLogin"
        v-if="templateId === 1"></template-light>
      <template-text
        :baseData="baseData"
        :query="param"
        :itemStatus="itemStatus"
        :rightClass="rightClass"
        :exceptionUA="exceptionUA"
        :logout.sync="logout"
        :needFocus.sync="needFocus"
        @login="handleLogin"
        v-if="templateId === 2"></template-text>
    </div>
    <!-- 强制关注页面 -->
    <Focus v-if="baseData && needFocus"
      :needFocus.sync="needFocus"
      :qrcodeURL="baseData.app_qr_code"
      :keyWord="baseData.key_word" />
  </div>
</template>

<script>
import { getInit, getShareCount } from 'api'
import TemplateLight from './TemplateLight.vue'
import TemplateText from './TemplateText.vue'
import Focus from '@/components/Focus.vue'

export default {
  name: 'index',
  data() {
    return {
      env: 'wx', // 默认微信wx，客户端app
      param: null, // 请求参数
      loading: true,
      message: '',
      notWxDisplay: false, // 公众号活动不在微信中打开
      templateId: 0, // 模板id
      baseData: null, // 项目基本数据
      itemStatus: 0, // 活动状态，0表示正常，1表示未开始，2表示已结束
      rightClass: true, // 在当前的用户组中，有参与活动的权限
      logout: false, // 仅针对客户端中
      needFocus: false, // 是否强制关注
      exceptionUA: null, // 非期UA
    }
  },
  watch: {
    '$route' (to, from) {
      // 活动地址
      sessionStorage.setItem('URL', window.location.href)
      this.init()
    }
  },
  created() {
    // 活动地址
    sessionStorage.setItem('URL', window.location.href)
    this.init()
  },
  methods: {
    init() {
      this.param = this.$route.query
      // 判断环境，是否是客户端
      this.isClient = sessionStorage.getItem('isClient') === '1'
      // 初始化入口，判断环境
      if (this.isClient) {
        console.log('index app')
        let vm = this
        CP.get_unique_id(function (data) {
          vm.param.sessionid = data.unique_id
        })
        CP.get_account_id(function (data) {
          vm.param.account_id = data.account_id
          vm._getInit()
        })
        // 统计参数，channel
        CP.get_client_info(function (data) {
          sessionStorage.setItem('channel', data.client_code)
        })
      } else {
        this._getInit()
      }
    },
    _getInit() {
      // 重置模板
      this.templateId && (this.templateId = 0)
      getInit(this.param).then(res => {
        if (res.code === 5008) {
          // 授权跳转
          window.location.replace(res.data.url)
        } else if (res.code === 5016) {
          // 注册信息
          let url = `${res.data.url}&url=${encodeURIComponent(window.location.href)}`
          window.location.replace(url)
        } else if (res.code === 3001 || res.code === 5900 || res.code === 5902 || res.code === 5903 || res.code === 5915 || res.code === 4003 || res.code === 5011) {

          this.baseData = res.data
          // 初始化模板
          this.templateId = this.baseData.template_id
          // 初始化项目配置
          this.itemConfig()
          // 强制关注，5011或者接口中的暗示需要关注且没关注的情况
          if ((res.code === 5011) || (res.code === 3001 &&  (this.baseData.is_subscribe === 1 && this.baseData.is_subscribed !== 1))) {
            this.needFocus = true
          }
          // 非期UA
          if (res.code === 5900) {
            this.exceptionUA = {
              need_qrcode: this.baseData.need_qrcode,
              download_url: this.baseData.download_url
            }
          }
          // 非期组别
          if (res.code === 5915) {
            this.rightClass = false
          }
        } else {
          this.message = res.msg
        }
        this.loading = false
      })
    },
    itemConfig() {
      sessionStorage.setItem('baseData', JSON.stringify(this.baseData))
      // 初始化活动状态
      this.handleItemStatus()
      // 设置标题
      document.title = this.baseData.page_title
      // 主题色配置
      this.baseData.theme_color && document.querySelector('body').style.setProperty('--color', this.baseData.theme_color)
      // 设置分享
      this.handleShareConfig({
        title: this.baseData.share_title,
        desc: this.baseData.share_desc,
        link: this.baseData.share_url,
        img: this.baseData.share_thumbnail,
      })
      // 根据是否开启获取地理位置信息作为分支
      if (this.baseData.is_gps === 1) {
        this.getLocation()
      }
    },
    handleItemStatus() {
      // 活动状态，0表示正常，1表示未开始，2表示已结束
      const currentTime = Math.round(Date.now() / 1000)
      if (currentTime < this.baseData.start_time) {
        this.itemStatus = 1
      } else if (currentTime > this.baseData.end_time) {
        this.itemStatus = 2
      } else {
        this.itemStatus = 0
        // 客户端登录
        this.appLogin()
      }
    },
    handleLogin(data) {
      // 更新参数
      this.param.account_id = data.account_id
      this.param.sessionid = data.unique_id
      this._getInit()
    },
    appLogin() {
      if (!this.isClient) return
      let vm = this
      // 验证登陆
      CP.is_login(function(data) {
        // 已登录
        if (data.is_login == '0') {
          // 未登录，调用登陆页面
          CP.show_login(function(data) {
            // 表示当前登录状态为未登录的状态
            if (data.is_login === '0') {
              vm.logout = true
            } else if (data.is_login === '1') {
              vm.param.account_id = data.account_id
              vm.param.sessionid = data.unique_id
              vm._getInit()
            }
          })
        }
      })
    },
    handleShareConfig(shareConfig) {
      // 分享配置，先判断环境
      let vm = this
      CP.set_share({
        title: shareConfig.title,
        shareSummary: shareConfig.desc,
        shareTo: '',
        link: shareConfig.link,
        imgUrl: shareConfig.img,
        completed: function(data) {
          vm._getShareCount()
        },
        once: false
      })
    },
    _getShareCount() {
      getShareCount(this.param).then(res => {})
    },
    getLocation() {
      let vm = this
      CP.get_location_info(function (data) {
        // 参数添加经纬度信息
        if (data.lat) {
          vm.$set(vm.param, 'latitude', data.lat)
          vm.$set(vm.param, 'longitude', data.lon)
        }
      })
    },
    btnAction() {
      CP.close_page()
    }
  },
  components: {
    TemplateLight,
    TemplateText,
    Focus
  }
}
</script>

<style lang="stylus" scoped>
#index
  min-height: 100vh
  overflow: hidden
  .errorArea
    margin-top: 0.8rem
    display: flex
    flex-direction: column
    align-items: center
    .error
      margin-bottom: 0.24rem
      width: 50%
    .message
      margin-bottom: 0.6rem
      width: 80%
      text-align: center
    .btn
      width: 1rem
      height: 0.3rem
      line-height: 0.3rem
      background-color: #eb4c5e
      color: #fff
      text-align: center
      border-radius: 0.04rem
  .loadingArea
    margin-top: 1rem
    display: flex
    flex-direction: column
    align-items: center
    .loading
      margin-bottom: 0.1rem
      width: 0.4rem
      height:0.4rem
</style>

